import SDPHelpers from '../sdp_helpers';
import getMediaSectionsForAnswerDefault from './getMediaSectionsForAnswer';
import getMediaSectionsForOfferDefault from './getMediaSectionsForOffer';
import createLogger from '../../../helpers/log';

const logging = createLogger('partialSdp');

const isPartialSdp = sdp => sdp.tracks.length !== sdp.mids.length;

const createGetFullRemoteSdp = (deps = {}) => {
  const getMediaSectionsForAnswer = deps.getMediaSectionsForAnswer
    || getMediaSectionsForAnswerDefault;
  const getMediaSectionsForOffer = deps.getMediaSectionsForOffer || getMediaSectionsForOfferDefault;

  const getFullSdpFromPartial = (type, partialSdp, currentSdp) => {
    const isAnswer = type === 'answer';
    const version = Math.max(partialSdp.version, currentSdp.version || 0);
    const getMediaSections = isAnswer ? getMediaSectionsForAnswer : getMediaSectionsForOffer;
    const mediaSections = getMediaSections(partialSdp, currentSdp);
    const mids = mediaSections.map(SDPHelpers.getSectionMid);
    const tracks = mids.filter(mid => mid !== null);

    let headers;
    if (isAnswer) {
      headers = partialSdp.headers;
    } else {
      // We update the headers so bundle and credentials are the correct ones. Please note bundle
      // can have a different order in Mantis and Client.
      headers = SDPHelpers.updateHeadersInPartialSdp(currentSdp, partialSdp, tracks);
    }

    return {
      headers,
      version,
      bundle: SDPHelpers.createBundleLine(tracks),
      tracks,
      mediaSections,
      mids,
      iceCredentials: partialSdp.iceCredentials,
    };
  };

  const getFullRemoteSdp = (type, newRemoteSdp, currentRemoteSdp) => {
    if (!isPartialSdp(newRemoteSdp) && !currentRemoteSdp.bundle) {
      // This is a full SDP and it is the first received. When a full SDP comes after several SDP,
      // we don't return it since we want to merge the cached SDP and this full one. This can
      // happen, e.g., when SDPs come out of order.
      return newRemoteSdp;
    }

    logging.debug('partial remote sdp: ', newRemoteSdp);

    let partialSdp;
    if (currentRemoteSdp.bundle) {
      partialSdp = newRemoteSdp;
    } else {
      // This is a partial SDP, however it is the first one we have received (none cached yet), we
      // may need to add ICE credentials to the first enabled section.
      const { mediaSections, iceCredentials, headers } = newRemoteSdp;

      partialSdp = Object.assign({}, newRemoteSdp,
        { mediaSections: SDPHelpers.addIceConfig(mediaSections, headers, iceCredentials) });
    }

    return getFullSdpFromPartial(type, partialSdp, currentRemoteSdp);
  };

  return getFullRemoteSdp;
};

export default createGetFullRemoteSdp;
